function getShippingAndDeliveryDates() {
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const monthsOfYear = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  const holidays = (year) => [
    luxon.DateTime.fromObject({ year, month: 1, day: 1 }),
    luxon.DateTime.fromObject({ year, month: 1, day: 6 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 2 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 3 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 4 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 5 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 6 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 18 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 20 }),
    luxon.DateTime.fromObject({ year, month: 4, day: 21 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 1 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 29 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 6 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 8 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 21 }),
    luxon.DateTime.fromObject({ year, month: 11, day: 1 }),
    luxon.DateTime.fromObject({ year, month: 12, day: 24 }),
    luxon.DateTime.fromObject({ year, month: 12, day: 25 }),
    luxon.DateTime.fromObject({ year, month: 12, day: 26 }),
    luxon.DateTime.fromObject({ year, month: 12, day: 31 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 14 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 19 })  
  ];

  const blackoutDates = (year) => [
    luxon.DateTime.fromObject({ year, month: 4, day: 2 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 3 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 4 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 5 }), 
    luxon.DateTime.fromObject({ year, month: 4, day: 6 }),
    luxon.DateTime.fromObject({ year, month: 5, day: 14 }),
    luxon.DateTime.fromObject({ year, month: 6, day: 19 })   
  ];

  const isBlackoutDate = (date) => {
    const blackoutList = blackoutDates(date.year);
    return blackoutList.some(blackout => blackout.hasSame(date, 'day'));
  };

  let now = luxon.DateTime.now().setZone('Europe/Stockholm', { keepLocalTime: false });
  console.log("Testing date: " + now.toFormat('dd-MM-yyyy -- HH:mm') + " -- " + now.weekdayLong);

  const currentHour = now.hour;
  const currentDay = now.weekday;

  const pdpWidget = document.querySelector('.delivery__container');
  if(pdpWidget) {
    if (currentDay === 5) {
      document.querySelector('.delivery__container').style.display = 'none';
    } else {
      document.querySelector('.delivery__container').style.display = 'block';
    }

    if(isBlackoutDate(now)) {
      document.querySelector('.delivery__container').style.display = 'none';
    }
  }

  const isHoliday = (date) => {
    return holidays(date.year).some(holiday => holiday.hasSame(date, 'day'));
  };

  const getNextBusinessDay = (date, days = 1) => {
    while (days > 0) {
      date = date.plus({ days: 1 });
      if (date.weekday < 6 && !isHoliday(date)) {
        days--;
      }
    }
    return date;
  };

  let shippingDate, deliveryDate;

  if (currentDay >= 1 && currentDay <= 5) {
    if (currentHour < 15 && !isHoliday(now)) {
      shippingDate = now;
    } else {
      shippingDate = getNextBusinessDay(now);
    }
  } else {
    shippingDate = getNextBusinessDay(now);
  }
  
  deliveryDate = getNextBusinessDay(shippingDate, 2);
  const formatDate = (date) => {
    if (now.hasSame(date, 'day')) return "Today";
    if (date.hasSame(now.plus({ days: 1 }), 'day')) return "Tomorrow";
    return `${monthsOfYear[date.month - 1]} ${date.day}`;
  };

  return {
    shippingMessage: formatDate(shippingDate),
    deliveryMessage: formatDate(deliveryDate)
  };
}

document.addEventListener('DOMContentLoaded', function () {
  const shippingElement = document.querySelector('.date__estimated');
  const deliveryElement = document.querySelector('.date__delivery');

  if (shippingElement) {
    const { shippingMessage } = getShippingAndDeliveryDates();
    shippingElement.textContent = shippingMessage;
  }

  if (deliveryElement) {
    const { deliveryMessage } = getShippingAndDeliveryDates();
    deliveryElement.textContent = deliveryMessage;
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const countdownElement = document.querySelector('.countdown__timer');

  const now = luxon.DateTime.now().setZone('Europe/Stockholm', { keepLocalTime: false });

  console.log("Current date and time: ", now.toString());

  let targetTime;

  if ((now.weekday === 5 && now.hour >= 15) || now.weekday === 6) {
    console.log("The countdown will not be displayed because it is Friday after 2:00 PM or Saturday.");
    countdownElement.style.display = 'none';
    return;
  }

  if (now.hour >= 15) {
    targetTime = now.plus({ days: 1 }).set({
      hour: 15,
      minute: 0,
      second: 0
    }).setZone('Europe/Stockholm');
    
    console.log("Target date (tomorrow at 2:00 PM): ", targetTime.toString());
  } else {
    targetTime = luxon.DateTime.fromObject({
      year: now.year,
      month: now.month,
      day: now.day,
      hour: 15,
      minute: 0,
      second: 0
    }, { zone: 'Europe/Stockholm' });

    console.log("Target date (today at 2:00 PM): ", targetTime.toString());
  }

  const updateCountdown = () => {
    const now = luxon.DateTime.now().setZone('Europe/Stockholm', { keepLocalTime: false });
    const timeRemaining = targetTime.diff(now, ['hours', 'minutes', 'seconds']);
    
    const formatTime = (time) => {
      const hours = String(Math.max(0, Math.floor(time.hours))).padStart(2, '0');
      const minutes = String(Math.max(0, Math.floor(time.minutes))).padStart(2, '0');
      const seconds = String(Math.max(0, Math.floor(time.seconds))).padStart(2, '0');
      return `${hours}:${minutes}:${seconds}`;
    };

    // Update ONLY the time element, leaving the label untouched for Weglot translation
    const timeEl = countdownElement.querySelector('.countdown__time');
    if (timeEl) {
      timeEl.textContent = formatTime(timeRemaining);
    }

    if (timeRemaining.hours <= 0 && timeRemaining.minutes <= 0 && timeRemaining.seconds <= 0) {
      clearInterval(interval);
    }
  };

  updateCountdown();

  let interval = setInterval(updateCountdown, 1000);
});